// export const calendarData = {
//   events: [
//     { id: 1, title: "event 1", date: "2019-12-01" },
//     {
//       title: "event 2",
//       start: "2019-12-01",
//       end: "2019-12-05",
//       allDay: true,
//       HostName: "William",
//     },
//     {
//       title: "event 3",
//       start: "2019-12-05",
//       end: "2019-12-07",
//       allDay: true,
//     },
//     {
//       title: "event 4",
//       start: "2019-12-05",
//       end: "2019-12-07",
//       allDay: true,
//     },
//     {
//       title: "event 5",
//       start: "2019-12-05",
//       end: "2019-12-07",
//       allDay: true,
//     },
//     {
//       title: "event 6",
//       start: "2019-12-05",
//       end: "2019-12-07",
//       allDay: true,
//     },
//   ],
// };

export const calendarData = {
  events: [
    { title: "All Day Event", start: getDate("YEAR-MONTH-01") },
    {
      title: "Long Event",
      start: getDate("YEAR-MONTH-07"),
      end: getDate("YEAR-MONTH-10"),
      // allDay: true,
      // HostName: "William",
    },
    {
      groupId: "999",
      title: "Repeating Event",
      start: getDate("YEAR-MONTH-09T16:00:00+00:00"),
    },
    {
      groupId: "999",
      title: "Repeating Event",
      start: getDate("YEAR-MONTH-16T16:00:00+00:00"),
    },
    {
      title: "Conference",
      start: "YEAR-MONTH-17",
      end: getDate("YEAR-MONTH-19"),
    },
    {
      title: "Meeting",
      start: getDate("YEAR-MONTH-18T10:30:00+00:00"),
      end: getDate("YEAR-MONTH-18T12:30:00+00:00"),
    },
    { title: "Lunch", start: getDate("YEAR-MONTH-18T12:00:00+00:00") },
    { title: "Birthday Party", start: getDate("YEAR-MONTH-19T07:00:00+00:00") },
    { title: "Meeting", start: getDate("YEAR-MONTH-18T14:30:00+00:00") },
    { title: "Happy Hour", start: getDate("YEAR-MONTH-18T17:30:00+00:00") },
    { title: "Dinner", start: getDate("YEAR-MONTH-18T20:00:00+00:00") },
  ],
};

function getDate(dayString: any) {
  const today = new Date();
  const year = today.getFullYear().toString();
  let month = (today.getMonth() + 1).toString();

  if (month.length === 1) {
    month = "0" + month;
  }

  return dayString.replace("YEAR", year).replace("MONTH", month);
}
